import axios from '../Backend';


export const openContactOnCrm = async (id) => {
    try {
        const res = await axios.get(`/api/v2/crms/${id}`);
        const resData = res.data
        if (resData.status !== 'success') throw new Error('Unknown Error')
    } catch (e) {
        console.log('openContactOnCrm :: Error')
        console.log(JSON.stringify(e))
        if (e.response) {
            console.log('openContactOnCrm :: Response Error')
            console.log(JSON.stringify(e.response.data))
        }
        throw e
    }
}

export const openContactOnCrmAlways = async (crmId, phoneNumber) => {
    try {
      const finalId = crmId || 'null';
      let url = `/api/v2/crms/${finalId}`;
      if (phoneNumber) {
        url += `?channelNum=${phoneNumber}`;
      }
  
      const res = await axios.get(url);
      const resData = res.data;
      if (resData.status !== 'success') {
        throw new Error('Unknown Error');
      }
      return resData.data?.url || null;
    } catch (e) {
      console.log('openContactOnCrm :: Error', e);
      if (e.response) {
        console.log('openContactOnCrm :: Response Error', e.response.data);
      }
      throw e;
    }
  };

  export const openContactOnCrmAlwaysWithRelatedCallId = async (crmId, phoneNumber, relatedCallId) => {
    const finalId = crmId || 'null';
  
    await axios.get(`/api/v2/crms/${finalId}`, {
      params: {
        ...(phoneNumber && { channelNum: phoneNumber }),
        ...(relatedCallId && { relatedCallId })
      }
    });
  };